module.exports = __webpack_public_path__ + "static/img/preview.5a6f252e.jpg";